import React from 'react'
import clsx from 'classnames'
import type { Salon } from 'api/api.types'
import { formatPhone } from 'utils/formatPhone'
import styles from './VisitInfo.module.scss'

type SalonInfoProps = {
  salon: Salon | null | undefined,
  icon?: React.ReactNode,
  className?: string,
  withPhone?: boolean,
}

/** The salon address of a visit, optionally with its phone */
export const SalonInfo: React.FC<SalonInfoProps> = (props) => {
  const { salon, icon, className, withPhone = false } = props
  const salonVars = salon?.meta?.templateVars?.pageVars
  const address = salonVars?.salonAddress ?? 'Салон не доступен'
  const phone = salonVars?.salonPhones?.[0]?.phone ?? ''
  return (
    <div className={clsx([styles.info, className])}>
      {icon && <div className={styles.icon}>
        {icon}
      </div>}
      <div className={styles.salon}>
        <span>{address}</span>
        {withPhone && ', '}
        {(withPhone && salonVars) && (
          <a href={'tel:+' + phone}>
            {formatPhone(phone)}
          </a>
        )}
      </div>
    </div>
  )
}
